import { call, put, select } from 'redux-saga/effects'
import { t } from 'i18next'
import { selectTelecomAuthCommonData } from '@/containers/Login/AuthSelectors'
import { updateContractConfigData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import type {
  TelecomComparatorApiError,
  TelecomComparatorClientType,
  TelecomComparatorCommonData,
  TelecomComparatorOffersResponse,
  TelecomComparatorProductType,
} from './telecomComparatorTypes'

interface ApiRequest {
  endpoint?: string
  queryParams?: Record<string, string>
  showErrorSnackbar?: boolean
}

export const requestApi = callApi as unknown as (request: ApiRequest) => Generator

const ERROR_KEYS: Record<string, string> = {
  TELECOM_COMPARATOR_UNAVAILABLE: 'subscriptionForm:offer_module.telecom_comparator.unavailable',
  TELECOM_COMPARATOR_DISABLED: 'subscriptionForm:offer_module.telecom_comparator.disabled',
}

const isApiError = (error: unknown): error is TelecomComparatorApiError =>
  error instanceof Error && 'responseData' in error

export const telecomComparatorErrorMessage = (error: unknown): string => {
  const code = isApiError(error) ? error.responseData?.error?.code : undefined

  return t(ERROR_KEYS[code ?? ''] ?? 'subscriptionForm:offer_module.comparator_error')
}

export const telecomComparatorActions = {
  TELECOM_COMPARATOR_SEARCH: 'TELECOM_COMPARATOR_SEARCH',
}

export interface TelecomComparatorSearchAction {
  type: string
  id: number
  productType: TelecomComparatorProductType
  clientType: TelecomComparatorClientType
}

export function* fetchTelecomComparatorOffers({
  id,
  productType,
  clientType,
}: TelecomComparatorSearchAction): Generator {
  const { comparatorOffersUrl } = ((yield select(selectTelecomAuthCommonData)) ?? {}) as TelecomComparatorCommonData

  yield put(
    // @ts-ignore
    updateContractConfigData({
      id,
      data: {
        telecomComparatorLoading: true,
        telecomComparatorError: null,
      },
    }),
  )

  try {
    const response = (yield call(requestApi, {
      endpoint: comparatorOffersUrl,
      queryParams: { product_type: productType, client_type: clientType },
      showErrorSnackbar: false,
    })) as TelecomComparatorOffersResponse
    const offers = response?.data?.offers
    if (!Array.isArray(offers)) {
      throw new Error('The telecom comparator offers response has no offers list')
    }

    yield put(
      // @ts-ignore
      updateContractConfigData({
        id,
        data: { telecomComparatorLoading: false, telecomComparatorOffers: offers },
      }),
    )
  } catch (error: unknown) {
    yield put(
      // @ts-ignore
      updateContractConfigData({
        id,
        data: {
          telecomComparatorLoading: false,
          telecomComparatorOffers: [],
          telecomComparatorError: telecomComparatorErrorMessage(error),
        },
      }),
    )
  }
}
